import { graphql } from 'react-relay';

export type { NftMarketEntryQuery as NftMarketEntryQueryType } from './__generated__/NftMarketEntryQuery.graphql.ts';

export const NftMarketEntryQuery = graphql`
    query NftMarketEntryQuery(
        $itemCount: Int = 40
        $after: String
        $page: Int
        $auctionStatuses: [NftItemSearchAuctionStatus!]
        $auctionMarketTypes: [NftItemSearchAuctionMarketType!]
        $mediumTypes: [NftItemSearchMediumType!]
        $sortBy: NftItemSearchSort
        $search: String = ""
        $userId: String = ""
        $fetchUser: Boolean = false
    ) {
        viewer {
            nftItemSearch(
                first: $itemCount
                after: $after
                page: $page
                auctionStatuses: $auctionStatuses
                auctionMarketTypes: $auctionMarketTypes
                mediumTypes: $mediumTypes
                sortBy: $sortBy
                search: $search
            ) {
                pageInfo {
                    hasNextPage
                }
            }
            nftItemSearchFacets: nftItemSearch(first: 0) {
                facets {
                    facetField
                    facetValues {
                        value
                        count
                    }
                }
            }
            ...NftMarketLayout_viewer
            ...NftHeaderLayout_viewer
        }
    }
`;
